module.exports = __webpack_public_path__ + "static/media/personal.e0ef17db.png";